export default __webpack_public_path__ + "static/media/Arch_Amazon-EC2_64.9f3a476f.svg";